import { TextV2, useToast } from '@withjoy/joykit';
import { LayoutAddComponentListItem } from '@website-editor/features/custom-page/components/LeftPanelLayouts/LayoutAddComponentListItem';
import { useCreateNewJsonComponent } from '../../hooks/useJsonBlobStorageUtils';
import React from 'react';
import { Rsvp } from '@withjoy/joykit/icons';
import { AdminSidebarComponentProps } from '../../JsonComponent.types';
import { SimpleGrabHandle } from '../SimpleGrabHandle';
import { useUpdateWebsitePreview } from '@website-editor/hooks/useUpdateWebsitePreview';
import { useCustomComponentStateContext } from '@website-editor/features/custom-page/context/CustomComponentStateContext/CustomComponentState.context';
import { JsonDataContainerFragment } from '@graphql/generated';
import { useTranslation } from '@shared/core';
import { useGoToEditorView } from '../../hooks/useJsonComponentNavigation';

export const FormDisplayGrabber = (props: AdminSidebarComponentProps) => {
  const { tq } = useTranslation('formCustomComponent');
  return (
    <SimpleGrabHandle
      title={tq`Form`}
      icon={<Rsvp size={32} />}
      {...props}
    ></SimpleGrabHandle>
  );
};

export const FormDisplayAdd = (props: AdminSidebarComponentProps) => {
  const { createNewJsonComponent } = useCreateNewJsonComponent(props.eventHandle);
  const { updateWebsitePreview } = useUpdateWebsitePreview();
  const { setRefetchQueries } = useCustomComponentStateContext<JsonDataContainerFragment>();
  const { tq } = useTranslation('formCustomComponent');
  const { goToEditorView } = useGoToEditorView();
  const { toast } = useToast();

  const handleClick = () => {
    createNewJsonComponent({
      schemaURL: 'https://withjoy.com/assets/public/schemas/FormCustomComponentV1_0_0.json',
      type: 'FormDisplay',
      initialData: {
        formId: '',
        type: 'embedded',
      },
      containerId: props.containerId,
    }).then(data => {
      // Request a refetch of the components list to update the left panel
      setRefetchQueries(['PageContainerBySlug']);

      // Then update the preview
      updateWebsitePreview();

      if (data.componentData && data.containerData.data) {
        goToEditorView({ ...data.componentData, __typename: 'JsonDataBlobComponent', containerContent: { ...data.containerData.data, __typename: 'JsonDataContainer' } });
      } else {
        toast('Error creating component');
      }
    });
  };

  return (
    <LayoutAddComponentListItem onClick={handleClick}>
      <Rsvp size={48} />
      <TextV2
        typographyVariant="hed2"
        textAlign="left"
      >
        {tq`Form`}
      </TextV2>
    </LayoutAddComponentListItem>
  );
};
